import React from 'react'
import Navbar from '../components/Navbar/Navbar'
import Bearer from '../components/Bearer/Bearer'

function BearerPage() {
  return (
    <>
    <Navbar/>
    <Bearer/>
    </>
  )
}

export default BearerPage
